<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="id"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Name" />
      <dx-column data-field="id" caption="Network ID" />
      <dx-column data-field="driver" caption="Driver" />
      <dx-column data-field="scope" caption="Scope" />
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow
} from 'devextreme-vue/data-grid';

import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';  

export default {
  name: 'DockerNetworksView',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Docker Networks',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadNetworks();
  },
  methods: {
    async loadNetworks() {
      try {
        const response = await axios.get('/api/internal/docker/networks');
        this.dataSource = response.data;
      } catch (err) {
        console.error('Error loading Docker networks:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}

.tag-expired {
  background-color: #f44336;
}

.tag-error {
  background-color: #d32f2f;
  max-width: 250px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
